import { Component, OnInit } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AccountService, AlertService } from '@app/_services'

@Component({
    templateUrl: 'login.component.html',
    standalone: true,
    imports: [ReactiveFormsModule, NgClass, NgIf]
})
export class LoginComponent implements OnInit {
    form!: FormGroup;
    loading = false;
    submitted = false;
    returnUrl = '/';

    constructor(
        private formBuilder: FormBuilder,
        public route: ActivatedRoute,
        private router: Router,
        private accountService: AccountService,
        private alertService: AlertService
    ) {
        if (this.route.snapshot.queryParams['returnUrl'] && this.route.snapshot.queryParams['returnUrl'] != '/')
            this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
        this.accountService.login('x', 'x').pipe(first()).subscribe(user => {
            if (user) {
                const returnUrl = this.returnUrl != '/' ? this.returnUrl : 
                    user.role == 'admin' ? '/devices': '/';    
                this.router.navigateByUrl(returnUrl);
            }
        });
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            email: ['', Validators.required],
            password: ['', Validators.required]
        });
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        this.accountService.login(this.f.email.value, this.f.password.value)
            .pipe(first())
            .subscribe({
                next: (user) => {
                    // get return url from query parameters or default to home page
                    //const returnUrl = user.role == 'admin' ? '/devices' : '/';
                    //const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
                    const returnUrl = this.route.snapshot.queryParams['returnUrl'] != '/' ? this.route.snapshot.queryParams['returnUrl'] : 
                        user.role == 'admin' ? '/devices': '/';    
                    this.router.navigateByUrl(returnUrl);
                },
                error: error => {
                    this.alertService.error(error);
                    this.loading = false;
                }
            });
    }

    get returnSSOUrl() { return '/account/sso?returnUrl=' + this.returnUrl; }
}
